import React from "react";
import { useParams, useHistory } from "react-router-dom";
import { Typography, Card, Table, Button } from "antd";
import {
  useGetPlatformProjectCreditsQuery,
  useGetPlatformProjectDetailsQuery,
} from "./store/registryplatformprojectsapi";
import { RegistryDisplayOrganizationName } from "./RegistryDisplayOrgName";

function RegistryTransactionPageView() {
  const { id } = useParams();
  const history = useHistory();

  const { data: projectData, isLoading } = useGetPlatformProjectDetailsQuery(
    id,
    {
      skip: !id,
    }
  );
  const project = projectData?.data;

  const { data: creditsData } = useGetPlatformProjectCreditsQuery(id, {
    skip: !id,
  });
  const yieldData = creditsData?.data?.yields;

  const handleGoBack = () => {
    history.push({
      pathname: `/${id}`,
    });
  };

  const transactionColumns = [
    {
      title: "Period",
      dataIndex: "period",
      key: "period",
      render: (record) => {
        return (
          <Typography.Text style={{ fontFamily: "Lexend", fontSize: 16 }}>
            {record}
          </Typography.Text>
        );
      },
    },
    {
      title: "Organization",
      key: "organization",
      render: () => {
        return (
          <Typography.Text style={{ fontFamily: "Lexend", fontSize: 16 }}>
            {<RegistryDisplayOrganizationName name={project?.organizationName} />}
          </Typography.Text>
        );
      },
    },
    {
      title: "Credit Type",
      key: "credittype",
      render: (record) => {
        return record.preCredits !== null && record.preCredits !== undefined
          ? "Proba Pre-Credit"
          : null;
      },
    },
    {
      title: "Quantity",
      dataIndex: "preCredits",
      key: "preCredits",
      render: (record) => {
        const formattedRecord = record != null ? (record === 0 ? "-" : null) || (record % 1 !== 0 ? record.toFixed(4).replace(/\.?0+$/, '') : record.toFixed(0)) : "-";
        return (
          <Typography.Text style={{ fontFamily: "Lexend", fontSize: 16 }}>
            {formattedRecord}
          </Typography.Text>
        );
      },
    },
  ];

  const filteredYieldData = yieldData?.filter(
    (data) => data?.preCredits !== null && data?.preCredits !== undefined
  );

  return (
    <div>
      {!isLoading && (
        <div style={{ height: "80vh" }}>
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "space-between",
            }}
          >
            <Typography.Title level={2} style={{ fontFamily: "Lexend" }}>
              {project?.name}
            </Typography.Title>
            <div style={{ textAlign: "right" }}>
              <Button
                type="primary"
                onClick={handleGoBack}
                style={{ backgroundColor: "#36B28D", color: "white" }}
              >
                Back
              </Button>
            </div>
          </div>

          <Typography.Title
            level={2}
            style={{ fontFamily: "Lexend", marginTop: "2rem" }}
          >
            Transaction
          </Typography.Title>
          <div>
            <Card>
              <Table
                dataSource={filteredYieldData?.filter(record => record?.preCredits !== null && record?.preCredits !== 0)}
                columns={transactionColumns}
                pagination={{
                  pageSizeOptions: ["10", "50", "100"],
                  showSizeChanger: true,
                }}
              />
            </Card>
          </div>
        </div>
      )}
    </div>
  );
}

export default RegistryTransactionPageView;
